<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />

        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" />Draft Retur Inventaris
            </h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Faktur: <strong>{{ data.no_faktur || "-" }}</strong
                    ><br />
                    Status:
                    <b-badge :variant="getStatusBadge(data.status)[0]">{{
                        getStatusBadge(data.status)[1]
                    }}</b-badge>
                    <br />

                    <template v-if="data.approved_at">
                        Disetujui oleh
                        <strong>{{ data.approved_by }}</strong> pada
                        <strong>
                            {{ $helper.parseDate(data.approved_at) }},
                            {{ $helper.parseHourMinute(data.approved_at) }}
                        </strong>
                        <br />
                    </template>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="danger" @click="cancelReturnKirimInvent">
                        <i class="fa fa-times mr-2" />Batalkan
                    </b-button>
                    <b-button
                        variant="success"
                        class="ml-2"
                        @click="finalisasiRetur"
                    >
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col md="6" class="mb-3">
                    <b-input-group>
                        <b-input
                            v-model="input.noFaktur"
                            maxlength="100"
                            style="max-width: 250px"
                            placeholder="Input No. Faktur..."
                            @keydown.enter="addItem"
                        />
                        <b-input-group-append>
                            <b-button
                                variant="dark"
                                @click="addItem"
                                :disabled="isEditing"
                                >Tambah Barang</b-button
                            >
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                :busy="isBusy"
                no-local-sorting
                :items="items"
                :fields="fields"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Tidak ada barang.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }}
                    <span v-if="row.item.year != null"
                        >({{ row.item.year }})</span
                    >
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                    </div>
                </template>
                <template v-slot:cell(note)="row">
                    {{ row.item.note || "-" }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        size="sm"
                        variant="danger"
                        v-b-tooltip.hover.top
                        title="Hapus"
                        :disabled="isEditing"
                        @click="removeItem(row.item)"
                    >
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <b-modal
            id="m-print"
            title="Cetak Invoice"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
        >
            Invoice berhasil dibuat. Tekan bagian "Sinar Mutiara Cell" untuk
            mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            Pastikan kirim inventaris sudah tercetak dengan baik sebelum
            melanjutkan.
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button
                            variant="dark"
                            :disabled="invoiceSizeCooldown"
                            @click="toggleInvoiceSize"
                        >
                            Print {{ invoiceSize == "A5" ? "A4" : "A5" }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="hideInvoiceModal">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            isEditing: false,
            isBusy: false,

            input: {
                noFaktur: ""
            },

            data: {},
            items: [],

            fields: [
                { key: "no", label: "No." },
                {
                    key: "noFakturImei",
                    label: "No. Faktur & IMEI / SN",
                    sortable: false
                },
                { key: "barang", label: "Barang", sortable: false },
                { key: "note", label: "Catatan", sortable: false },
                { key: "action", label: "Aksi" }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            invoiceLink: "",
            invoiceLinkA4: "",

            invoiceSize: "A5",
            invoiceSizeCooldown: false
        };
    },

    methods: {
        init() {
            this.initStatus = 0;

            let getItems = this.getItems().catch(error =>
                this.$helper.parseError(this, error)
            );

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => (this.initStatus = -1));
        },

        getItems(page) {
            this.isBusy = true;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("return-inventory-pgi/" + this.$route.params.id + param)
                .then(res => {
                    this.items = res.data.data.details.items;
                    this.totalRows = res.data.data.details.total;
                    this.data = res.data.data;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isBusy = false;
                });
        },

        addItem() {
            if (this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi nomor faktur!"
                );
            }

            let payload = {
                no_faktur: this.input.noFaktur
            };

            this.isEditing = true;

            this.$axios
                .post(
                    "return-inventory-pgi/" + this.$route.params.id + "/item",
                    payload
                )
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Barang berhasil ditambahkan!"
                    );
                    this.input.noFaktur = "";
                    this.getItems();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isEditing = false));
        },

        removeItem(item) {
            let confirmed = confirm(
                `Hapus ${item.type} (NF ${
                    item.no_faktur_pgi
                }) dari return kirim inventaris ini?`
            );
            if (!confirmed) return;

            this.isEditing = true;

            this.$axios
                .delete(
                    "return-inventory-pgi/" +
                        this.$route.params.id +
                        "/item/" +
                        item.id
                )
                .then(() => {
                    this.$helper.toastSuccess(this, "Barang berhasil dihapus!");
                    this.getItems();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isEditing = false));
        },

        cancelReturnKirimInvent() {
            let isConfirmed = confirm(
                "Batalkan return inventaris ini? Draft akan dihapus dan barang-barang akan dikembalikan ke status semula!"
            );
            if (!isConfirmed) return;

            this.$axios
                .delete("return-inventory-pgi/" + this.$route.params.id)
                .then(() => {
                    this.$router.push({ path: "/kirim-inven/retur" });
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        finalisasiRetur() {
            if (this.items.length == 0) {
                return this.$helper.toastError(
                    this,
                    "Belum ada barang yang akan dipindahkan!"
                );
            }

            let isConfirmed = confirm(
                "Finalisasi retur ini? Proses ini tidak dapat dibatalkan!"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            const payload = {
                sendback_return_id: parseInt(this.$route.params.id)
            };
            this.$axios
                .post("return-inventory-pgi/finalize", payload)
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        `Return Kirim Invent berhasil dijalankan! barang berhasil dipindahkan.`
                    );

                    const cleanedString = res.data.data.link.replace(/\\/g, "");
                    const cleanedStringa4 = res.data.data.linka4.replace(
                        /\\/g,
                        ""
                    );

                    this.invoiceLink = `${
                        this.$BASE_PRINT_FILE_PATH
                    }${cleanedString}`;
                    this.invoiceLinkA4 = `${
                        this.$BASE_PRINT_FILE_PATH
                    }${cleanedStringa4}`;
                    this.$bvModal.show("m-print");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        hideInvoiceModal() {
            this.$router.push({ path: "/kirim-inven/retur" });
            this.$bvModal.hide("m-print");
        },

        getInvoiceLink() {
            if (this.invoiceSize == "A5") {
                return this.invoiceLink;
            } else {
                return this.invoiceLinkA4;
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true;
            if (this.invoiceSize == "A5") this.invoiceSize = "A4";
            else this.invoiceSize = "A5";
            setTimeout(
                function() {
                    this.invoiceSizeCooldown = false;
                }.bind(this),
                2000
            );
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["dark", "DRAFT"];
                case 1:
                    return ["warning", "PENDING"];
                case 2:
                    return ["success", "APPROVED"];
                default:
                    return ["light", "-"];
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style></style>
